import { createElement, useRef, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@max/leez-text';
import AnimateView from '@max/mbc-animate-view';
import { Animated } from '@max/mbc-animated';
import { buttonStyle } from '../../lib/constant';
import '../../common.scss';
import './index.scss';
export default function CouponButton(props) {
    const { btnText, maxInflateAmount, size } = props;
    const buttonHeight = buttonStyle.btnSizeNumber[size].height;
    const containerHeight = buttonStyle.btnSizeNumber[size].height * 2;
    const transformXValue = useRef(new Animated.Value(0)).current;
    const playAnimation = () => {
        Animated.loop(Animated.sequence([Animated.timing(transformXValue, {
                toValue: -buttonHeight,
                duration: 300,
                delay: 2000,
                useNativeDriver: false
            }), Animated.timing(transformXValue, {
                toValue: -containerHeight,
                duration: 300,
                delay: 2000,
                useNativeDriver: false
            }), Animated.timing(transformXValue, {
                toValue: 0,
                duration: 0,
                useNativeDriver: false
            })]), {
            iterations: Infinity,
            resetBeforeIteration: true
        }).start();
    };
    useEffect(() => {
        playAnimation();
    }, []);
    const animateStyle = {
        transform: [{
                translateY: transformXValue
            }]
    };
    return <AnimateView animateStyles={animateStyle}>
      {[btnText, maxInflateAmount ? `最高至${maxInflateAmount}` : btnText, btnText].map((item, index) => {
            return <View style={Object.assign(Object.assign({}, buttonStyle.btnSize[size]), { textAlign: 'center' })} className="row-center">
            <Text color="#FFF" type={size === 'big' ? 'title4' : 'title5'} lineClamp={1}>
              {item}
            </Text>
          </View>;
        })}
    </AnimateView>;
}
